import React from "react";
import { Button, Icon } from "semantic-ui-react";
import "./cmp-delete-modal.css";

export default function MDL_DELETE({
  onCancel,
  onSubmit,
  title = "Delete Confirmation",
  heading = "Are you sure you want to delete this item?",
  message = "This action cannot be undone. The selected item will be permanently removed from the system.",
  showPestPacWarning = false,
}) {
  return (
    <>
      {/* Header */}
      <div className="modal-header">
        <div className="modal-header-title">{title}</div>

        <div className="modal-header-close" onClick={onCancel}>
          <Icon name="times circle outline" />
        </div>
      </div>

      {/* Content */}
      <div className="delete-modal-content">
        <div className="delete-icon-wrapper">
          <Icon name="trash alternate outline" size="huge" color="red" />
        </div>

        <div className="delete-message">
          <div className="delete-heading">{heading}</div>

          <div className="delete-subtitle">{message}</div>
        </div>

        {showPestPacWarning && (
          <div className="delete-pestpac-warning">
            <Icon name="exclamation triangle" />
            <span>By deleting this, It will also delete the order on PestPac</span>
          </div>
        )}
      </div>
      {/* Footer */}
      <div className="modal-footer">
        <Button basic color="grey" onClick={onCancel}>
          Cancel
        </Button>

        <Button
          color="red"
          onClick={() => {
            onCancel();
            onSubmit();
          }}
        >
          Confirm
        </Button>
      </div>
    </>
  );
}
